import { h } from 'preact';

export const DownloadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2451 15.2734H3.12109V17.7934H15.2451V15.2734Z" fill="black" />
    <path d="M9.00023 13.061C9.30823 13.061 9.58823 12.949 9.81223 12.753L17.2322 6.39699L15.6082 4.49299L10.2602 9.05699V0.208984H7.74023V9.05699L2.39223 4.46498L0.740234 6.36898L8.16023 12.753C8.41223 12.949 8.69223 13.061 9.00023 13.061Z" fill="black" />
  </svg>
);
